import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "min-w-[150px] z-10" }
const _hoisted_2 = { class: "relative mt-1" }
const _hoisted_3 = { class: "block truncate" }
const _hoisted_4 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }
const _hoisted_5 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}

import {ref, watchEffect, watch } from 'vue'
import {
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'
import * as web3 from "@solana/web3.js"

type Network = { name: string, endpoint: string }

export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkDropdown',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: Network['name']
}




const networks: Network[] = [
  { name: 'devnet', endpoint: web3.clusterApiUrl("devnet") },
  { name: 'mainnet-beta', endpoint: web3.clusterApiUrl("mainnet-beta") },
]
const defaultNetwork = networks.find((n) => n.name === props.modelValue || networks[0])!
const selectedNetwork = ref<Network>(defaultNetwork)

watchEffect(() => {
  emit('update:modelValue', selectedNetwork.value.name)
})

watch(() => props.modelValue, (newVal) => {
  const targetNetwork = networks.find((n) => n.name === newVal)
  if (targetNetwork) {
    selectedNetwork.value = targetNetwork
  }
}, {
  immediate: true,
  flush: "pre"
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Listbox), {
      modelValue: selectedNetwork.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedNetwork).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ListboxButton), { class: "relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(selectedNetwork.value.name), 1),
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_unref(SelectorIcon), {
                  class: "h-5 w-5 text-gray-400",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "leave-active-class": "transition duration-100 ease-in",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ListboxOptions), { class: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(networks, (network) => {
                    return _createVNode(_unref(ListboxOption), {
                      key: network.name,
                      value: network,
                      as: "template"
                    }, {
                      default: _withCtx(({ active, selected }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass([
                  active ? 'bg-amber-100 text-amber-900' : 'text-gray-900',
                  'relative cursor-default select-none py-2 pl-10 pr-4',
                ])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([
                    selected ? 'font-medium' : 'font-normal',
                    'block truncate',
                  ])
                          }, _toDisplayString(network.name), 3),
                          selected
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _createVNode(_unref(CheckIcon), {
                                  class: "h-5 w-5",
                                  "aria-hidden": "true"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  }), 64))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})